var pastNumberAccordionTemplate = require('./past-numbers-accordion.handlebars');
var loadingDotsTemplate = require('./../../../shared/templates/loading-dots-row-template.handlebars');
var Pager = require('./../../../shared/components/pager/pagerService');
var generateUniqueId = require('./../../../shared/scripts/generateMostlyUniqueId');

var pastNumbersService__TAB = new pastNumbersService();
var pastNumbersService__COLLAPSE = new pastNumbersService();
var pastNumbersPager__TAB = new Pager();
var pastNumbersPager__COLLAPSE = new Pager();


$(function () {
    //Draw game detail
    if (!$('.past-numbers-container').length) return;

    //Initialize
    initializePastNumber_TAB();
    initializePastNumber_COLLAPSE();

    //on TAB SHOWN, get data, build/insert handlebars template into TAB
    $(`[data-target="#${pastNumbersService__TAB.parentId}"]`).on('shown.bs.tab', function () {
        pastNumbersPager__TAB.setCurrentPage(0);
        getPastNumbersData_TAB();        
    });

    //on COLLAPSE SHOWN, get data, build/insert handlebars template into COLLAPSE
    $(`#${pastNumbersService__COLLAPSE.parentId}`).on('shown.bs.collapse', function () {
        pastNumbersPager__COLLAPSE.setCurrentPage(0);
        getPastNumbersData_COLLAPSE();
    });
});

function initializePastNumber_TAB() {
    pastNumbersService__TAB.parentId = $('.past-numbers-container').parents('.tab-pane').attr('id');
    pastNumbersService__TAB.accordionId = $(`#${pastNumbersService__TAB.parentId}`).find('[id^=accordion-pastnumbers_]').attr('id');
    pastNumbersPager__TAB.setPagerId('pastnumbers__TAB-pager');
    pastNumbersPager__TAB.setPagerContainerSelector(`#${pastNumbersService__TAB.parentId} .pastnumbers-pager`);

    let requestedPageSize = parseInt($(`${pastNumbersPager__TAB.getPagerContainerSelector()}`).data('page-size'));
    (Number.isInteger(requestedPageSize))
        ? pastNumbersPager__TAB.setPageSize(requestedPageSize)
        : pastNumbersPager__TAB.setPageSize(pastNumbersService__TAB.options.pageSize);

    pastNumbersService__TAB.options.gameId = $(`${pastNumbersPager__TAB.getPagerContainerSelector()}`).data('game-id');
}

function initializePastNumber_COLLAPSE() {
    pastNumbersService__COLLAPSE.parentId = $('.past-numbers-container').parents('.collapse.panel-collapse').attr('id');
    pastNumbersService__COLLAPSE.accordionId = $(`#${pastNumbersService__COLLAPSE.parentId}`).find('[id^=accordion-pastnumbers_]').attr('id');
    pastNumbersPager__COLLAPSE.setPagerId('pastnumbers__COLLAPSE-pager');
    pastNumbersPager__COLLAPSE.setPagerContainerSelector(`#${pastNumbersService__COLLAPSE.parentId} .pastnumbers-pager`);

    let requestedPageSize = parseInt($(`${pastNumbersPager__COLLAPSE.getPagerContainerSelector()}`).data('page-size'));
    (Number.isInteger(requestedPageSize))
        ? pastNumbersPager__COLLAPSE.setPageSize(requestedPageSize)
        : pastNumbersPager__COLLAPSE.setPageSize(pastNumbersService__COLLAPSE.options.pageSize);

    pastNumbersService__COLLAPSE.options.gameId = $(`${pastNumbersPager__COLLAPSE.getPagerContainerSelector()}`).data('game-id');
}

function getPastNumbersData_TAB() {
    showIsLoadingIcon(`#${pastNumbersService__TAB.accordionId}`);

    pastNumbersService__TAB.options.pageSize = pastNumbersPager__TAB.getPageSize();
    pastNumbersService__TAB.options.page = pastNumbersPager__TAB.getCurrentPage();

    $.ajax({
        url: '/api/v1/drawnumbers',
        type: 'POST',
        data: pastNumbersService__TAB.options,
        dataType: 'json'
    })
        .done(function (data) {
            //let isDayNightGame = data.data[0].DailyDraws.length > 1;
			//isDayNightGame = (pastNumbersService__TAB.options.gameId==1040||pastNumbersService__TAB.options.gameId==1050?true:false);
			let isDayNightGame = (pastNumbersService__TAB.options.gameId==1030||pastNumbersService__TAB.options.gameId==1040||pastNumbersService__TAB.options.gameId==1050?true:false);

			  //alert( data.data[0].DailyDraws.length);
			//alert(pastNumbersService__TAB.options.gameId);
            var html = pastNumberAccordionTemplate({
                pastDraws: data.data,
                isDayNightGame: isDayNightGame,
                accordionId: pastNumbersService__TAB.accordionId,
                isKenoGame:(pastNumbersService__TAB.options.gameId==30?true:null)
            });
            $(`#${pastNumbersService__TAB.accordionId}`).html(html);
            pastNumbersPager__TAB.update(pastNumbersPager__TAB.getPagerId(), pastNumbersPager__TAB.getPagerContainerSelector(), getPastNumbersData_TAB, data.totalPages, data.currentPage);
            $('.panel.panel-default.1030').each(function(){
                var numbers=$(this).find('.panel-title .selected-numbers li').length;
                if(numbers>=12){
                    var label="<div class='panel panel-default cash5gamesplitter center'>"
                    +"<div class='panel-heading'><div class='panel-title'>"
                    +"On October 26, 2020, Cash 5 game became Virginia's newest jackpot game with drawings every night with jackpot's starting at $100,000."
                    +"<p style='margin-bottom: 4px;'></div></div></div>";
                    $(label).insertBefore($(this));
                    return false;
                }
            });
            $('.panel.panel-default.1030').each(function(){
                var numbers=$(this).find('.panel-title .selected-numbers li').length;
                if(numbers<=12){
                $(this).find('.panel-title .selected-numbers li.drawing-type').hide();   
                }             
            });
        });
}
function getPastNumbersData_COLLAPSE() {
    showIsLoadingIcon(`#${pastNumbersService__COLLAPSE.accordionId}`);

    pastNumbersService__COLLAPSE.options.pageSize = pastNumbersPager__COLLAPSE.getPageSize();
    pastNumbersService__COLLAPSE.options.page = pastNumbersPager__COLLAPSE.getCurrentPage();
    $.ajax({
        url: '/api/v1/drawnumbers',
        type: 'POST',
        data: pastNumbersService__COLLAPSE.options,
        dataType: 'json'
    })
        .done(function (data) {
           // let isDayNightGame = data.data[0].DailyDraws.length > 1;
            //let isDayNightGame = (pastNumbersService__TAB.options.gameId==1030||pastNumbersService__TAB.options.gameId==1040||pastNumbersService__TAB.options.gameId==1050?true:false);
			let isDayNightGame = (pastNumbersService__TAB.options.gameId==1040||pastNumbersService__TAB.options.gameId==1050?true:false);
            let isCash5Night = data.data[0].DailyDraws.length > 1
            var html = pastNumberAccordionTemplate({
                pastDraws: data.data,
                isDayNightGame: isDayNightGame,
                accordionId: pastNumbersService__COLLAPSE.accordionId,
                uniqueId: pastNumbersService__COLLAPSE.uniqueId,
                isKenoGame:(pastNumbersService__TAB.options.gameId==30?true:null)
            });
			//alert(isDayNightGame);
			
            $(`#${pastNumbersService__COLLAPSE.accordionId}`).html(html);

            //Stop event propagation from nested collapsible
            $(`#${pastNumbersService__COLLAPSE.accordionId}`).on('shown.bs.collapse', function (e) {
                e.stopPropagation();
            });

            pastNumbersPager__COLLAPSE.update(pastNumbersPager__COLLAPSE.getPagerId(), `#${pastNumbersService__COLLAPSE.parentId} .pastnumbers-pager`, getPastNumbersData_COLLAPSE, data.totalPages, data.currentPage);

            //$('.panel.panel-default .panel-title .selected-numbers')
            $('.panel.panel-default').each(function(){
                console.log('numbers count: '+$(this).find('.panel-title .selected-numbers li').length);
            });
        });
}

function showIsLoadingIcon(containerSelector) {
    var html = loadingDotsTemplate();
    $(containerSelector).html(html);
}

function pastNumbersService(options) {
    var pastNumbersDefaultOptions = {
        page: 0,
        totalPages: 0,
        pageSize: 6,
        gameId: undefined
    };

    this.options = $.extend(true, pastNumbersDefaultOptions, options);
    this.parentId = ""; //tab or collapse id
    this.accordionId = "";
    //Generate some kind of 'unique' id to be used for collapsible data-target ids
    this.uniqueId = generateUniqueId();
}




// WEBPACK FOOTER //
// ./features/draw-games/past-numbers/past-numbers.js